<!-- 전역 다이얼로그 컴포넌트 (useDialog와 연동) -->
<template>
  <Teleport to="body">
    <Transition name="dialog">
      <div
        v-if="dialogState.isOpen"
        class="fixed inset-0 z-[9999] flex items-center justify-center"
      >
        <!-- 오버레이 -->
        <div class="absolute inset-0 bg-black/50" @click="handleCancel" />

        <!-- 다이얼로그 -->
        <div class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden">
          <!-- 헤더 -->
          <div v-if="dialogState.title" class="px-6 py-4 border-b border-gray-200">
            <h3 class="text-lg font-semibold text-gray-900">
              {{ dialogState.title }}
            </h3>
          </div>

          <!-- 본문 -->
          <div class="px-6 py-5">
            <p class="text-gray-700 whitespace-pre-line">
              {{ dialogState.message }}
            </p>
          </div>

          <!-- 버튼 -->
          <div class="px-6 py-4 bg-gray-50 flex justify-end gap-3">
            <!-- 취소 버튼 (confirm 타입일 때만) -->
            <button
              v-if="dialogState.type === 'confirm'"
              @click="handleCancel"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition"
            >
              {{ dialogState.cancelText }}
            </button>

            <!-- 확인 버튼 -->
            <button
              @click="handleConfirm"
              class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition"
            >
              {{ dialogState.confirmText }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
  import { useDialog } from '@/composables/useDialog'

  const { dialogState, closeDialog } = useDialog()

  function handleConfirm() {
    closeDialog(true)
  }

  function handleCancel() {
    closeDialog(false)
  }
</script>

<style scoped>
  .dialog-enter-active,
  .dialog-leave-active {
    transition: opacity 0.2s ease;
  }

  .dialog-enter-from,
  .dialog-leave-to {
    opacity: 0;
  }

  .dialog-enter-active > div:last-child,
  .dialog-leave-active > div:last-child {
    transition: transform 0.2s ease;
  }

  .dialog-enter-from > div:last-child,
  .dialog-leave-to > div:last-child {
    transform: scale(0.95);
  }
</style>
